import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { ReactiveFormsModule } from '@angular/forms';

import { ComponentsModules } from '../shared/components/components.module';
import { PipesModules } from '../shared/pipes/pipes.modules';

import { ExampleListItemComponent } from './example-list-item/example-list-item.component';
import { ExampleDetailComponent } from './example-detail/example-detail.component';


@NgModule({
  declarations: [
    ExampleListItemComponent,
    ExampleDetailComponent,
  ],
  imports: [
    CommonModule,
    RouterModule,
    ReactiveFormsModule,
    ComponentsModules,
    PipesModules,
  ],
  exports: [
    ExampleListItemComponent,
    ExampleDetailComponent,
  ],
})
export class ExampleSharedModule {}
